// defines zoom lens - use between 0.1 (big zoom) and 1 (no zoom).
export const ZOOM_LENS = 0.4; // zoom is 40% of the image

const getDimensions = (image) => {
    const dimensions = {
        imageWidth: 0,
        imageHeight: 0,
        lensWidth: 0,
        lensHeight: 0,
        rx: 0,
        ry: 0,
    };
    if (!image) return dimensions;

    const { offsetWidth, offsetHeight } = image;
    const lensWidth = offsetWidth * ZOOM_LENS;
    const lensHeight = offsetHeight * ZOOM_LENS;
    // avoid divide by 0
    const rx = lensWidth > 0 ? offsetWidth / lensWidth : 0;
    const ry = lensHeight > 0 ? offsetHeight / lensHeight : 0;

    return {
        ...dimensions,
        imageWidth: offsetWidth,
        imageHeight: offsetHeight,
        // round off upto 2 decimal places
        lensWidth: Math.round(lensWidth * 100) / 100,
        lensHeight: Math.round(lensHeight * 100) / 100,
        rx: Math.round(rx * 100) / 100,
        ry: Math.round(ry * 100) / 100,
    };
};

export default getDimensions;
